export function getStaticImageSrc<TFilePath extends string>(
  filePath: TFilePath,
): `/static/images/${TFilePath}` {
  return `/static/images/${filePath}`;
}
